<div class="munily-file-drop-uploader">
  <label *ngIf="label" class="munily-file-drop-uploader__label">{{ label }}</label>

  <div
    class="munily-file-drop-uploader__zone"
    role="button"
    tabindex="0"
    [class.is-drag-over]="isDragOver"
    [class.is-error]="hasError"
    [class.is-disabled]="disabled"
    [attr.aria-disabled]="disabled"
    (click)="onZoneClick()"
    (keydown)="onZoneKeydown($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <mat-icon class="material-symbols-rounded mi munily-file-drop-uploader__icon" aria-hidden="true">
      {{ hasError ? 'error' : 'cloud_upload' }}
    </mat-icon>
    <p class="munily-file-drop-uploader__title">{{ displayTitle }}</p>
    <p class="munily-file-drop-uploader__hint">{{ displayHint }}</p>
    <p *ngIf="showFormatsLine" class="munily-file-drop-uploader__formats">{{ formatsLine }}</p>
  </div>

  <input
    #fileInput
    type="file"
    class="munily-file-drop-uploader__input"
    [accept]="acceptedFormats"
    [multiple]="multiple"
    [disabled]="disabled"
    (change)="onInputChange($event)"
  />

  <ul *ngIf="uploadedFiles.length > 0" class="munily-file-drop-uploader__file-list">
    <li *ngFor="let file of uploadedFiles; let i = index" class="munily-file-drop-uploader__file-item">
      <mat-icon class="material-symbols-rounded mi munily-file-drop-uploader__file-icon" aria-hidden="true">
        {{ file.icon === 'pdf' ? 'picture_as_pdf' : file.icon === 'image' ? 'image' : 'draft' }}
      </mat-icon>
      <div class="munily-file-drop-uploader__file-meta">
        <p class="munily-file-drop-uploader__file-name">{{ file.name }}</p>
        <p class="munily-file-drop-uploader__file-size">{{ formatFileSize(file.size) }}</p>
      </div>
      <button
        type="button"
        class="munily-file-drop-uploader__remove"
        [attr.aria-label]="'common-components.fileUploader.removeFile' | translate"
        (click)="removeFile(i); $event.stopPropagation()"
      >
        <mat-icon class="material-symbols-rounded mi" aria-hidden="true">close</mat-icon>
      </button>
    </li>
  </ul>

  <p *ngIf="hasError" class="munily-file-drop-uploader__error" role="alert">{{ errorMessage }}</p>
</div>
